import { gsap } from "gsap";
import { lightOrDark } from '../utils';

export default class ColorManager {
    constructor() {
        this.blobs = document.querySelectorAll('[data-blob]');
        this.logo = document.querySelector('[data-logo-svg]');
        this.logoTexts = this.logo.querySelector('.texts').querySelectorAll('text');
    }

    init(container) {
        const color = container.dataset.color;
        const background = container.dataset.background;

        this.setTo(color, background);
    }

    getColor(hexCode, opacity) {
        let hex = hexCode.replace('#', '');
        if (hex.length === 3) {
            hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
        }

        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        /* Backward compatibility for whole number based opacity values. */
        if (opacity > 1 && opacity <= 100) {
            opacity = opacity / 100;
        }
        return `rgba(${r},${g},${b},${opacity})`;
    }

    getColorRGB(hexCode) {
        let hex = hexCode.replace('#', '');
        if (hex.length === 3) {
            hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
        }

        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        return `${r},${g},${b}`;
    }

    fadeTo(container, duration) {
        const color = container.dataset.color;
        let background = container.dataset.background;
        if(!background) {
            const brightness = lightOrDark(color);
            background = 'black';
            if(brightness=='dark') {
                background = 'white';
            }
        }
        const textColor = this.getColor(color, 0.8);
        const textColorRGB = this.getColorRGB(color);

        gsap.to(document.documentElement, {
            "--color": color,
            "--background": background,
            "--textColor": textColor,
            "--textColorRGB": textColorRGB,

            duration: duration,
            ease: 'power2.inOut',
        });
    }

    setTo(color, background) {
        this.prevColor = color;

        const textColor = this.getColor(color, 0.8);
        const textColorRGB = this.getColorRGB(color);

        if(color) {
            document.documentElement.style.setProperty('--color', color);
        }
        if(background) {
            document.documentElement.style.setProperty('--background', background);
        }
        if(textColor) {
            document.documentElement.style.setProperty('--textColor', textColor);
        }
        if(textColorRGB) {
            document.documentElement.style.setProperty('--textColorRGB', textColorRGB);
        }

        gsap.set(this.blobs, {
            clearProps: 'fill',
        });
        gsap.to(this.logoTexts, {
            clearProps: 'fill'
        });
        gsap.set(this.logo, {
            clearProps: 'opacity'
        });
    }

    makeLogoGreen() {
        gsap.set(this.blobs, {
            fill: '#00FF2C',
        });
        gsap.to(this.logoTexts, {
            fill: 'black'
        });
        gsap.set(this.logo, {
            opacity: 1
        });
    }

}